import { fetchPost } from '../query/request'

const maxStackLength = 200

export async function logErrorToService({
    message,
    stack,
    name,
}: {
    message: string
    stack?: string
    name?: string
}) {
    const trimmedStack =
        stack && stack.length > maxStackLength
            ? stack.slice(0, maxStackLength) + '...'
            : (stack ?? '')

    const {
        location: { hostname: host, href: url },
    } = globalThis

    await fetchPost(
        `/v1/ClientLog`,
        JSON.stringify({ host, errorName: name, message, stack: trimmedStack, url }),
    )
}

export async function logToService({ name, message }: { name: string; message: string }) {
    const {
        location: { hostname: host, href: url },
    } = globalThis

    await fetchPost(
        `/v1/ClientLog`,
        JSON.stringify({ host, errorName: name, message, stack: '', url }),
    )
}
